import styled from 'styled-components';
import { getInviteBrandColors } from '../../brandColors';

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.semantic.surface.card};
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme, $variant }) =>
      getInviteBrandColors($variant, theme).secondary};
  }

  &:focus {
    outline: 0;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.semantic.surface.muted};
  color: ${({ theme, $variant }) =>
    getInviteBrandColors($variant, theme).secondary};
`;

export const Content = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
`;

export const Description = styled.span`
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;
